import type { ProductPackage } from '@/types/auth';
import { Eyebrow, Heading, Lede, Note, StepBody } from '../OnboardingShell';

const OPTIONS: { value: ProductPackage; title: string; detail: string }[] = [
  { value: 'seo', title: 'SEO', detail: 'The long game — articles and search' },
  { value: 'ads', title: 'Ads', detail: 'Paid search, faster leads' },
  { value: 'both', title: 'Both', detail: 'SEO and Ads together' },
];

export function PackageGate({
  selected,
  onSelect,
}: {
  selected: ProductPackage | null;
  onSelect: (pkg: ProductPackage) => void;
}) {
  return (
    <StepBody>
      <Eyebrow>Before we start</Eyebrow>
      <Heading>What do you want to set up?</Heading>
      <Lede>
        This decides which jobs show up next. You'll still need your website and where you
        work before we can create your business.
      </Lede>
      <div className="space-y-2.5">
        {OPTIONS.map((opt) => {
          const active = selected === opt.value;
          return (
            <button
              key={opt.value}
              type="button"
              aria-label={opt.title}
              onClick={() => onSelect(opt.value)}
              className={[
                'w-full text-left rounded-lg border px-4 py-3.5 transition-colors',
                'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
                active
                  ? 'border-coral bg-coral-light'
                  : 'border-warm-border bg-warm-bg hover:border-warm-border-strong',
              ].join(' ')}
            >
              <p className="text-[13px] font-semibold text-foreground">{opt.title}</p>
              <p className="text-xs leading-relaxed text-teal mt-0.5">{opt.detail}</p>
            </button>
          );
        })}
      </div>
      <div className="mt-4">
        <Note>
          If you have WordPress access, keep the plugin key handy. If you don't, skip that
          later — it does not block creating your business.
        </Note>
      </div>
    </StepBody>
  );
}
